import React from 'react';
import { RecordedVideo } from 'contexts/ScreenRecorderContext';
import { FormattedMessage, useIntl } from 'react-intl';

interface RecordingSuccessModalProps {
  recordedVideo: RecordedVideo;
  onClose: () => void;
  onDownload: () => void;
  onConfirmClose?: () => void;
}

const RecordingSuccessModal: React.FC<RecordingSuccessModalProps> = ({
  recordedVideo,
  onClose,
  onDownload,
  onConfirmClose,
}) => {
  const intl = useIntl();

  const handleClose = () => {
    const confirmed = window.confirm(
      intl.formatMessage({
        id: 'recording.close_confirm',
        defaultMessage:
          'The video is being uploaded to session content. You can safely close this window and continue editing. Click OK to close.',
      }),
    );
    if (confirmed) {
      if (onConfirmClose) {
        onConfirmClose();
      } else {
        onClose();
      }
    }
  };

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '16px',
        zIndex: 5000,
        pointerEvents: 'none',
      }}
    >
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '24px',
          width: '100%',
          maxWidth: '500px',
          overflow: 'hidden',
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
          pointerEvents: 'auto',
        }}
      >
        {/* Modal Header */}
        <div
          style={{
            backgroundColor: '#14b24c',
            padding: '16px 20px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            color: 'white',
          }}
        >
          <span style={{ fontWeight: 'bold', fontSize: '18px' }}>
            <FormattedMessage
              id="recording.successful"
              defaultMessage="Recording Successful"
            />
          </span>
          <button
            onClick={handleClose}
            style={{
              background: 'none',
              border: 'none',
              color: 'white',
              cursor: 'pointer',
              fontSize: '24px',
            }}
          >
            &times;
          </button>
        </div>

        {/* Modal Body */}
        <div style={{ padding: '20px' }}>
          <div
            style={{
              width: '100%',
              aspectRatio: '16/9',
              backgroundColor: 'black',
              borderRadius: '12px',
              overflow: 'hidden',
              marginBottom: '20px',
            }}
          >
            <video
              src={recordedVideo.url}
              controls
              style={{ width: '100%', height: '100%' }}
            />
          </div>

          <div style={{ display: 'flex', gap: '12px' }}>
            <button
              onClick={onDownload}
              style={{
                width: '100%',
                backgroundColor: '#14b24c',
                color: 'white',
                padding: '12px',
                borderRadius: '12px',
                fontWeight: 'bold',
                border: 'none',
                cursor: 'pointer',
              }}
            >
              <FormattedMessage
                id="recording.download_video"
                defaultMessage="Download Video"
              />
            </button>
          </div>

          <p
            style={{
              marginTop: '16px',
              textAlign: 'center',
              fontSize: '11px',
              color: '#9ca3af',
              fontWeight: 'bold',
            }}
          >
            {recordedVideo.uploadStatus === 'success' ? (
              <FormattedMessage
                id="recording.video_saved_success"
                defaultMessage="VIDEO SAVED SUCCESSFULLY"
              />
            ) : (
              <FormattedMessage
                id="recording.video_being_saved"
                defaultMessage="VIDEO IS BEING SAVED TO SESSION CONTENT"
              />
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default RecordingSuccessModal;
